/**
 * CSV de registro: tiempo acumulado en ms (enteros, como el informe anterior) y masas en kg (sin × g).
 * En BD `tiempo` está en segundos; si ya viene en ms (pruebas antiguas), no se vuelve a convertir.
 */

function filaCsv(valores) {
    return valores
        .map((v) => {
            const n = Number(v);
            return Number.isFinite(n) ? String(n) : String(v ?? "");
        })
        .join(",");
}

/** Convierte `tiempo` de la muestra a milisegundos enteros para el CSV. */
function tiempoMsParaCsv(muestras, muestra) {
    const t = Number(muestra.tiempo ?? 0);
    if (!muestras.length) return Math.round(t);

    const vals = muestras.map((m) => Number(m.tiempo ?? 0));
    const maxT = Math.max(...vals, 0);

    let deltaMedio = 0;
    if (vals.length > 1) {
        const deltas = [];
        for (let i = 1; i < Math.min(vals.length, 30); i++) {
            const d = vals[i] - vals[i - 1];
            if (d > 0) deltas.push(d);
        }
        if (deltas.length) deltaMedio = deltas.reduce((a, b) => a + b, 0) / deltas.length;
    }

    // Pruebas antiguas: tiempo ya acumulado en ms (saltos ~5–15, máximo >> 1 s en valor bruto)
    const yaEnMilisegundos = maxT > 15 && deltaMedio >= 1;

    if (yaEnMilisegundos) return Math.round(t);
    return Math.round(t * 1000);
}

export function buildCsvDatosEsp32(prueba) {
    const tipo = prueba?.tipoPrueba ?? prueba?.impresion ?? "";
    const esDynamo = tipo === "Dynamo";

    const muestras = prueba?.sistema_de_pesos_y_tiempos;
    if (!Array.isArray(muestras) || muestras.length === 0) {
        return null;
    }

    const header = esDynamo
        ? ["Tiempo [ms]", "Kg"]
        : ["Tiempo [ms]", "Fuerza pie izquierdo [kg]", "Fuerza pie derecho [kg]"];

    const filas = [filaCsv(header)];
    for (const m of muestras) {
        const tMs = tiempoMsParaCsv(muestras, m);
        if (esDynamo) {
            filas.push(filaCsv([tMs, m.masa?.combinada ?? 0]));
        } else {
            filas.push(filaCsv([tMs, m.masa?.izq ?? 0, m.masa?.der ?? 0]));
        }
    }
    return filas.join("\n");
}

export function blobCsvDatosEsp32(prueba) {
    const csv = buildCsvDatosEsp32(prueba);
    if (!csv) return null;
    return new Blob([csv], { type: "text/csv;charset=utf-8" });
}
